/**
 * Created by andermurias on 25/6/17.
 */
import React, {Component} from 'react';
import TextBlock from './TextBlock';

import '../../styles/elements/resumeDownload.css';

class ResumeDownload extends Component {
  render() {

    const content = (
      <div className='resume-donwload__content'>
        <h3 className="resume-donwload__title">Do you want to know <span className="red">more</span>?</h3>
        <div className='resume-download__text'>
          If you like my resume and want a detailed version, you can see a PDF version here in <a href="/files/resume/spanish.pdf" target="_blank" rel="noopener noreferrer" className='resume-download__link red'>Spanish</a> and <a href="/files/resume/english.pdf" target="_blank" rel="noopener noreferrer" className='resume-download__link red'>English</a>.

        </div>
      </div>
    );

    return (
      <div className={'resume-download' + (this.props.className ? this.props.className : '')}>
        <TextBlock content={content}
                   className="text-block--last text-block--left text-block--small-left"/>
      </div>
    )
  }


}

export default ResumeDownload;



// WEBPACK FOOTER //
// ./src/js/elements/ResumeDownload.js